import requester from '@/utils/request'
export default {
  // 查询钱包交易记录
  walletRecord: (params: object | undefined) =>
    requester.post('/wallet/v1/record/query', params, { headers: { isSeller: true } }),
  // 估算费用
  estimate: (params: object | undefined) =>
    requester.post('/nft/commodity/v1/estimate', params, { headers: { isSeller: true } }),
  estimateUSDT: (params: object | undefined) =>
    requester.post('/wallet/transaction/v1/gasEstimateTransferUsdt', params, {
      headers: { isSeller: true },
    }),
  // eth转账到指定钱包
  transferETH: (params: object | undefined) =>
    requester.post('/wallet/transaction/v1/transfer', params, { headers: { isSeller: true } }),
  transferUSDT: (params: object | undefined) =>
    requester.post('/wallet/transaction/v1/transfer/usdt', params, { headers: { isSeller: true } }),
  transferUSDC: (params: object | undefined) =>
    requester.post('/wallet/transaction/v1/transfer/usdc', params, { headers: { isSeller: true } }),
  transferSOL: (params: object | undefined) =>
    requester.post('/wallet/transaction/v1/transfer/sol', params, { headers: { isSeller: true } }),
  // 获取合约里的eth总额
  getBalanceOfContract: (params: object | undefined) =>
    requester.post('/seller/wallet/getBalanceOfContract', params, { headers: { isSeller: true } }),
  // 获取信任钱包 list
  getTrustWalletList: () =>
    requester.get('/wallet/v1/trust-wallet/list', {}, { headers: { isSeller: true } }),
}
